import { getAppConfig } from '../../config';
import { UserRole } from '../../models/organization/dto/invite-to-organization.dto';
import { canManageOrgResources } from '../../routes/access-policy';
import { useUserRole } from '../auth/roles';
import { useSelectedOrganization } from '../organization/hooks/useSelectedOrganization';

/**
 * Who sees the Accueil onboarding guides: the « Démo · 1 min 15 » video and the
 * live « Visite guidée » (the Onboarding Lab's `HomeGuideCards`, opened by the
 * launcher mounted in the admin layout).
 *
 * Promoted to production on 2026-11-03 (Onboarding Lab ledger, Q2): every club,
 * except the ones listed in the environment config's
 * `onboardingGuidesHiddenForOrganizationIds` — clubs that were already onboarded
 * by hand. Admins only: the tour walks the admin sidebar (courts, coaches,
 * pricing…), which a coach does not have.
 *
 * Deliberately outside the Lab's folder: that folder is the `onlab` routine's
 * fence, and who sees the guides is a human decision.
 */
export function showsOnboardingGuides(
    organizationId: string | undefined,
    role: UserRole,
    hiddenFor: readonly string[] = getAppConfig()?.onboardingGuidesHiddenForOrganizationIds ?? [],
): boolean {
    if (!organizationId || !canManageOrgResources(role)) return false;
    const id = organizationId.toLowerCase();
    return !hiddenFor.some((hidden) => hidden.toLowerCase() === id);
}

/** `showsOnboardingGuides` for the selected organization and the viewer's role in it. */
export function useShowsOnboardingGuides(): boolean {
    const selectedOrganization = useSelectedOrganization.use.selectedOrganization();
    const role = useUserRole();
    return showsOnboardingGuides(selectedOrganization?.id, role);
}
